import { api } from "./api";

let cache = { data: null, fetchedAt: 0 };
const TTL_MS = 60 * 1000;

export async function getCachedDashboardSummary(force = false) {
  const now = Date.now();
  if (!force && cache.data && now - cache.fetchedAt < TTL_MS) {
    return { data: cache.data };
  }
  const res = await api.getDashboardSummary();
  cache = { data: res.data, fetchedAt: now };
  return res;
}

export function invalidateDashboardCache() {
  cache = { data: null, fetchedAt: 0 };
}
